import React from "react";
import {setLoader} from "../../Store/Slice/techsbookSlice";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";


export default function JobFormModal({showFormDetails, setShowFormDetails, formJobIobId = null}) {
  const dispatch = useDispatch();
  const { jobFormData, activeJob } = useSelector((state) => state.rootReducer.jobsSlice);

  const downloadPDF = (jobId, formId) => {
    dispatch(setLoader(true))
    const token = localStorage.getItem('techsbook_customer_portal_token')
    const link = document.querySelector('#downloadPDF')
    axios({
      url: `${process.env.REACT_APP_API_URL_DEVELOP}/jobs/${jobId}/form/download/${formId || ''}`,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then((res) => {
        link.href = window.URL.createObjectURL(new Blob([res.data]))
        link.setAttribute('download', `${jobFormData?.provider_company} ${jobFormData?.vehicle_info?.vehicle_label ? '& ' + jobFormData?.vehicle_info?.vehicle_label : ''}.pdf`)
        link.click()
        link.removeAttribute('href')
        link.removeAttribute('download')
        dispatch(setLoader(false))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <>
      {showFormDetails && <div className="formDetails">
        <div className="formDetails__content">
          <div className="formDetails__top">
            <p className="formDetails__top-title">Form details</p>
            <div onClick={() => {
              setShowFormDetails(false)
            }} className="formDetails__close">
              <img src="/assets/icons/close.svg" alt="close"/>
            </div>
          </div>
          <div className="formDetails__inner">
            <div className="formDetails__logo">
              <img src="/assets/images/tbLogo.png" alt="techsbook"/>
            </div>
            <a target="_blank" id="downloadPDF">
              <div className="formDetails__btn" onClick={() => {
                downloadPDF(formJobIobId ?? activeJob?.id, jobFormData?.form_id)
              }}>
                <span><img src="/assets/icons/download.svg" alt="download"/></span>
                <p>Download PDF</p>
              </div>
            </a>
          </div>
          <table className="formDetails__table" style={{width: '100%', borderCollapse: 'collapse'}}>
            <tbody>
            <p className="formDetails__title">Cover Data</p>
            <tr>
              <td>Customer Name</td>
              <td>{jobFormData?.provider_customer_name ? jobFormData?.provider_customer_name : '--- --- ---'}</td>
            </tr>
            <tr>
              <td>Scheduled  time</td>
              <td>{jobFormData?.job_datetime ? jobFormData?.job_datetime : '--- --- ---'}</td>
            </tr>
            <tr>
              <td>Completed time</td>
              <td>{jobFormData?.completed_date ? jobFormData?.completed_date : '--- --- ---'}</td>
            </tr>
            {/*<tr>*/}
            {/*  <td>Ticket number</td>*/}
            {/*  <td>{jobFormData?.ticket_number ? jobFormData?.ticket_number : 'n/a'}</td>*/}
            {/*</tr>*/}
            <tr>
                <td>Verification Key</td>
                <td>{jobFormData?.verification_key ? jobFormData?.verification_key : 'n/a'}</td>
            </tr>
            <tr>
              <td>Tracking number</td>
              <td>{jobFormData?.tracking_number && jobFormData?.tracking_number !== 'null' ? jobFormData?.tracking_number : 'n/a'}</td>
            </tr>
            <tr>
              <td>Latitude, Longitude</td>
              <td>{jobFormData?.coordinates?.lat + ' ' + jobFormData?.coordinates?.lon}</td>
            </tr>
            </tbody>
          </table>

          {
            jobFormData?.show_vehicle_forms ? (
              <table className="formDetails__table" style={{width: '100%', borderCollapse: 'collapse'}}>
              <tbody>
                <p className="formDetails__title">Vehicle Data</p>
                <tr>
                  <td>VIN</td>
                  <td>{jobFormData?.vehicle_info?.vin ? jobFormData?.vehicle_info?.vin : '--- --- ---'}</td>
                </tr>
                <tr>
                  <td>Label</td>
                  <td>{jobFormData?.vehicle_info?.vehicle_label ? jobFormData?.vehicle_info?.vehicle_label : '--- --- ---'}</td>
                </tr>
                <tr>
                  <td>License Plate</td>
                  <td>{jobFormData?.vehicle_info?.license_plate ? jobFormData?.vehicle_info?.license_plate : '--- --- ---'}</td>
                </tr>
                <tr>
                  <td>Make & Model</td>
                  <td>{`${jobFormData?.vehicle_info?.make ? jobFormData?.vehicle_info?.make : '---'}` + ' ' + `${jobFormData?.vehicle_info?.model ? jobFormData?.vehicle_info?.model : '--- ---'}`}</td>
                </tr>
                <tr>
                  <td>Year</td>
                  <td>{jobFormData?.vehicle_info?.year ? jobFormData?.vehicle_info?.year : '--- --- ---'}</td>
                </tr>
                {jobFormData?.images?.map((item, index) => (
                  <tr key={index}>
                    <td>Prior damage images</td>
                    <td>
                      <img style={{width: '100%', maxWidth: '200px'}} src={item?.path} alt=""/>
                    </td>
                  </tr>
                ))}
              </tbody>
          </table>
            ) : ''
          }
          

          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <tbody>
            <p className="formDetails__title">Job Data</p>
            {
              jobFormData?.items?.map((item, index) => (
                <div key={index} className="formDetails__jobData">
                  <p className="formDetails__jobData-title">Item : {item?.name}</p>
                  {
                    item?.fields?.map((field, idx) => (
                      <tr key={idx}>
                        {
                          field?.type === 'file' && (
                            <>
                              <td>{field?.label}</td>
                              <td><img src={field?.answer[1]} alt=""/></td>
                            </>
                          )
                        }
                        {
                          field?.type === 'checkbox' && (
                            <>
                              <td>{field?.label}</td>
                              <td>
                                {
                                  field?.answer?.map((answ, answIdx) => (
                                    <div key={answIdx}>{answ}</div>
                                  ))
                                }
                              </td>
                            </>
                          )
                        }
                        {
                          field?.type === 'toggle' && (
                            <>
                              <td>{field?.label}</td>
                              {
                                field?.answer[0] !== '0' ?
                                  <td>
                                    <div style={{
                                      background: '#5dc546',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      width: '24px',
                                      height: '24px'
                                    }}>
                                      <img src="/assets/icons/check-icon.svg" alt=""/>
                                    </div>
                                  </td> : field?.answer[0] !== '1' ?
                                    <td>
                                      <div style={{
                                        background: '#FF4040',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '24px',
                                        height: '24px'
                                      }}>
                                        <img style={{width: "unset"}} src="/assets/icons/x.svg" alt=""/>
                                      </div>
                                    </td> : <></>
                              }
                            </>
                          )
                        }
                        {
                          field?.type === 'radio' && (
                            <>
                              <td>{field?.label}</td>
                              <td>{field?.options?.filter((el) => el.value === field?.answer[0])[0]?.label}</td>
                            </>
                          )
                        }
                        {
                          field?.type !== 'radio' && field?.type !== 'file' && field?.type !== 'checkbox' && field?.type !== 'toggle' && (
                            <>
                              <td>{field?.label}</td>
                              <td>{field?.answer[0]}</td>
                            </>
                          )
                        }
                      </tr>
                    ))
                  }
                </div>
              ))
            }
            </tbody>

          </table>
        </div>
        <div onClick={() => {
          setShowFormDetails(false)
        }} className="formDetails__bg"></div>
      </div>
      }
    </>
  )
}
